module.exports = __webpack_public_path__ + "img/Event_Icon_BreweryRelease_Blue.97d9e8f2.png";